import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getVerificationGateRedirect } from '../lib/emailVerificationFlow';

/**
 * Routes logged-in but unverified users away from sensitive authenticated
 * surfaces (owner dashboard, bookings, client dashboard) to the verification
 * pending page. Public browse and logged-out access are never blocked.
 */
export default function VerificationRouteGuard() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) {
      return;
    }
    const redirect = getVerificationGateRedirect(pathname, { user });
    if (redirect && redirect !== pathname) {
      navigate(redirect, { replace: true });
    }
  }, [pathname, user, loading, navigate]);

  return null;
}
